<p-card *ngIf="processo !== undefined">
  <app-processo-visualizador
    [processo]="processo"
    [mostrarComandoProcesso]="true"
    [tabViewIndex]="tabViewIndex"
    [tabViewDocumentosIndex]="tabViewDocumentosIndex">
  </app-processo-visualizador>
</p-card>
